import 'src/assets/scss/theme.scss';
import { IntlProvider } from 'react-intl';
import ModalLoaderProvider from 'src/components/ModalLoader/Provider';
import AppRoutes from 'src/routes/app-routes';
import AppUpdateDialog from 'src/features/sw-update/app-update-dialog';
import { Toaster } from 'src/components/ui/toaster';

const App: React.FC = () => {
  return (
    <ModalLoaderProvider>
      <IntlProvider locale={'en'}>
        <Toaster />
        <AppUpdateDialog />
        <AppRoutes />
      </IntlProvider>
    </ModalLoaderProvider>
  );
};

export default App;
